import React, { useState, Fragment } from "react";
import { Link } from "react-router-dom";
import { hot } from "react-hot-loader";
import classNames from "classnames";

import Drawer from "@material-ui/core/Drawer";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import Divider from "@material-ui/core/Divider";
import Box from "@material-ui/core/Box";

import Typography from "@material-ui/core/Typography";
import { withStyles } from "@material-ui/core/styles";

import EditIcon from "@material-ui/icons/Edit";
import MenuIcon from "@material-ui/icons/Menu";
import MediaIcon from "@material-ui/icons/PermMedia";
import PeopleIcon from "@material-ui/icons/People";
import TuneIcon from "@material-ui/icons/Tune";
import SubtitlesIcon from "@material-ui/icons/Subtitles";
import SettingsIcon from "@material-ui/icons/Settings";
import LockIcon from "@material-ui/icons/LockOpen";
import BathtubIcon from "@material-ui/icons/Bathtub";
import LabelIcon from "@material-ui/icons/Label";
import GroupWorkIcon from "@material-ui/icons/GroupWork";
import ViewModuleIcon from "@material-ui/icons/ViewModule";
import FileList from "../FileList";
import Dialog from "../ui/Dialog";
import firebase from "../../config/firebase";
import { store } from "../../Store";
import APP from "../../_actions/app";
import { Tooltip } from "@material-ui/core";
import { isGuest } from "../../utils/misc";

const styles = (theme) => ({
  drawerPaper: {
    zIndex: 12,
    position: "relative",
    whiteSpace: "nowrap",
    width: 210,
    background: "rgba(0,0,0, 0.9)",
    boxShadow: "0px 4px 4px 0px #000, 0px 0px 2px 0px #000",
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },

  drawerPaperClose: {
    overflowX: "hidden",
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    width: theme.spacing(7),
    [theme.breakpoints.up("sm")]: {
      width: theme.spacing(9),
    },
  },

  list: {
    padding: 0,
    "& svg, & span": {
      color: "#fff",
      fontSize: 16,
    },

    "& svg": {
      fontSize: 16,
      marginLeft: 12,
    },

    "& h6": {
      padding: "15px 15px 15px 25px",
      textTransform: "uppercase",
      fontSize: 14,
    },

    "& a, & > div": {
      textAlign: "center",
      borderLeft: "1px solid",
      borderColor: "transparent",

      "&:hover": {
        borderColor: theme.palette.primary.main,

        "& span, & svg": {
          color: theme.palette.primary.main,
        },
      },
    },

    "&.smallPadding div, &.smallPadding a": {
      padding: "6px 16px 6px 8px",
      textAlign: "left",
    },
  },

  toolbar: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    padding: "0 8px",
    marginBottom: "2px",
    minHeight: 54,
  },
});

const signOut = (e) => {
  e.preventDefault();
  firebase.auth.signOut();
};

const Nav = (props) => {
  const [showMedia, setShowMedia] = useState(false);

  const { classes } = props;

  return (
    <Fragment>
      {/* <Box display={showMedia ? 'block' : 'none'}> */}
      <Dialog
        style={{ display: showMedia ? "block" : "none" }}
        maxWidth="lg"
        title="Files"
        open
        onClose={() => setShowMedia(false)}
      >
        <FileList />
      </Dialog>
      {/* </Box> */}
      <Drawer
        variant="permanent"
        classes={{
          paper: classNames(
            classes.drawerPaper,
            !props.isOpen && classes.drawerPaperClose
          ),
        }}
        open={props.isOpen}
      >
        <div className={classes.toolbar} />
        <List
          className={classNames(classes.list, props.isOpen && "smallPadding")}
        >
          {props.isOpen && (
            <Box bgcolor="#252525" component="span" display="block">
              <Typography variant="subtitle2" color="secondary">
                Content
              </Typography>
            </Box>
          )}
          <Tooltip
            placement="right"
            title="Content"
            enterDelay={props.isOpen ? Infinity : 0}
          >
            <ListItem button component={Link} to="/edit">
              <ListItemIcon>
                <EditIcon />
              </ListItemIcon>
              {props.isOpen && <span>Content</span>}
            </ListItem>
          </Tooltip>
          {!isGuest() && (
            <Tooltip
              placement="right"
              title="Media"
              enterDelay={props.isOpen ? Infinity : 0}
            >
              <ListItem button onClick={() => setShowMedia(true)}>
                <ListItemIcon>
                  <MediaIcon />
                </ListItemIcon>
                {props.isOpen && <span>Media</span>}
              </ListItem>
            </Tooltip>
          )}
          {/* <ListItem button component={Link} to="/navigation">
          <ListItemIcon>
            <MenuIcon />
          </ListItemIcon>
          {props.isOpen && <span>Navigation</span>}
        </ListItem> */}
          {props.isOpen ? (
            <Box bgcolor="#252525" component="span" display="block">
              <Typography variant="subtitle2" color="secondary">
                Administration
              </Typography>
            </Box>
          ) : (
            <Divider />
          )}
          {/* <ListItem button component={Link} to="/schemas">
          <ListItemIcon>
            <SubtitlesIcon />
          </ListItemIcon>
          {props.isOpen && <span>Schemas</span>}
        </ListItem> */}
          {/* <ListItem button component={Link} to="/users">
          <ListItemIcon>
            <PeopleIcon />
          </ListItemIcon>
          {props.isOpen && <span>Users</span>}
        </ListItem> */}
          {/* <ListItem button component={Link} to="/permissions">
          <ListItemIcon>
            <TuneIcon />
          </ListItemIcon>
          {props.isOpen && <span>Permissions</span>}
        </ListItem> */}
          {!isGuest() && (
            <Tooltip
              placement="right"
              title="Admin"
              enterDelay={props.isOpen ? Infinity : 0}
            >
              <ListItem button component={Link} to="/admin">
                <ListItemIcon>
                  <SettingsIcon />
                </ListItemIcon>
                {props.isOpen && <span>Admin</span>}
              </ListItem>
            </Tooltip>
          )}
          <Tooltip
            placement="right"
            title="Sign Out"
            enterDelay={props.isOpen ? Infinity : 0}
          >
            <ListItem button component={Link} to="/login" onClick={signOut}>
              <ListItemIcon>
                <LockIcon />
              </ListItemIcon>
              {props.isOpen && <span>Sign Out</span>}
            </ListItem>
          </Tooltip>
          {isGuest() ? null : (
            <>
              {props.isOpen ? (
                <Box bgcolor="#252525" component="span" display="block">
                  <Typography variant="subtitle2" color="secondary">
                    Quick Links
                  </Typography>
                </Box>
              ) : (
                <Divider />
              )}
              {[
                { title: "Brands", icon: <LabelIcon />, link: "/edit/brands" },
                {
                  title: "Classification",
                  icon: <GroupWorkIcon />,
                  link: "/edit/classification",
                },
                {
                  title: "Products",
                  icon: <BathtubIcon />,
                  link: "/edit/products",
                },
              ].map((item) => (
                <Tooltip
                  placement="right"
                  title={item.title}
                  enterDelay={props.isOpen ? Infinity : 0}
                >
                  <ListItem button component={Link} to={item.link}>
                    <ListItemIcon>{item.icon}</ListItemIcon>
                    {props.isOpen && <span>{item.title}</span>}
                  </ListItem>
                </Tooltip>
              ))}
            </>
          )}
        </List>
      </Drawer>
    </Fragment>
  );
};

export default withStyles(styles)(hot(module)(Nav));
